const trustedDocuSignReturnHosts = new Set([
  'enrollment-qa.160digital.com',
  'enrollment.160digital.com',
  'partners-enrollment-qa.160digital.com',
  'partners-enrollment.160digital.com',
  'enrollment-qa.160drivingacademy.com',
  'enrollment.160drivingacademy.com',
  'partners-enrollment-qa.160drivingacademy.com',
  'partners-enrollment.160drivingacademy.com'
])

const getWidgetAssetOrigin = () => {
  const assetBase = (window as { __WIDGET_ASSET_BASE__?: string }).__WIDGET_ASSET_BASE__

  if (!assetBase) {
    return null
  }

  try {
    return new URL(assetBase).origin
  } catch {
    return null
  }
}

export const isTrustedDocuSignReturnOrigin = (origin: string) => {
  if (origin === window.location.origin) {
    return true
  }

  if (origin === getWidgetAssetOrigin()) {
    return true
  }

  try {
    return trustedDocuSignReturnHosts.has(new URL(origin).hostname)
  } catch {
    return false
  }
}
